import { useState, useEffect } from "react";
import { Navbar, Container, Nav, Button, Image } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "./supabaseClient";

export default function Navigation() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // 1. Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      const currentUser = session?.user ?? null;
      setUser(currentUser);
      if (currentUser) fetchProfile(currentUser.id);
    });
    const checkUser = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    const currentUser = session?.user ?? null;
    setUser(currentUser);
    
    // Check the JWT for the role
    const role = currentUser?.app_metadata?.role;
    setIsAdmin(role === 'admin'); 
  };
  checkUser();
    // 2. Listen for changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      const currentUser = session?.user ?? null;
      setUser(currentUser);
      if (currentUser) fetchProfile(currentUser.id);
      else setProfile(null);
    });

    return () => subscription.unsubscribe();
  
  }, []);

  async function fetchProfile(userId) {
    const { data, error } = await supabase
      .from("profiles")
      .select("full_name, avatar_url, job_position")
      .eq("id", userId)
      .single();

    if (!error && data) setProfile(data);
  }

  return (
    <Navbar expand="lg" className="shadow-sm mb-4 border-bottom" sticky="top">
      <Container>
        
        <Navbar.Brand as={Link} to={user ? "/dashboard" : "/"} className="fw-bold text-primary">
          <img src="/favicon.ico" alt="FLOC" width="30" height="30" className="me-2" />
            🇫🇱🇴🇨  
        </Navbar.Brand>
        
        <Nav className="ms-auto align-items-center">
          {user ? (
            <>
              <Button as={Link} to="/new" variant="primary" size="sm" className="me-3">
                + New Request
              </Button>

              {/* Profile Link */}
              <Nav.Link as={Link} to="/profile" className="d-flex align-items-center me-3">
                {profile?.avatar_url ? (
                  <Image src={profile.avatar_url} roundedCircle width="30" height="30" className="me-2 border" />
                ) : (
                  <div className="bg-secondary rounded-circle me-2" style={{ width: 30, height: 30 }} />
                )}
                <div className="d-none d-md-block">
                  <div className="small fw-bold leading-none" style={{ lineHeight: 1 }}>
                    {profile?.full_name || "Set Name"}
                  </div>
                  <div className="text-muted" style={{ fontSize: '0.7rem' }}>
                    {profile?.job_position || user.email}
                  </div>
                </div>
              </Nav.Link>
                {isAdmin && (
  <Nav.Link as={Link} to="/manager" className="text-danger fw-bold">
    PM Portal
  </Nav.Link>
)}
              <Button variant="outline-danger" size="sm" onClick={() => supabase.auth.signOut()}>
                Logout
              </Button>
            </>
          ) : (
            <Button variant="primary" size="sm" as={Link} to="/">Sign In</Button>
          )}
        </Nav>
      </Container>


    </Navbar>
  );
}